// The client-side driver registry: one entry per provider that supports
// `placement: 'client'`. Adding one is a file plus a line, same as the server's
// provider registry — and a server-placed session touches none of it.

import type { ClientProviderConfig } from '@shared/protocol.ts'
import { createEcho } from './echo.ts'
import { createLocalPipeline } from './local-pipeline.ts'
import { DriverConfigError, type ClientDriver, type DriverFactory, type DriverHost, type DriverOptions } from './types.ts'

const DRIVERS: Record<string, DriverFactory> = {
  'local-pipeline': createLocalPipeline,
  echo: createEcho,
}

export const CLIENT_DRIVER_IDS = Object.keys(DRIVERS)

export function createClientDriver(config: ClientProviderConfig, host: DriverHost, opts: DriverOptions = {}): ClientDriver {
  const factory = DRIVERS[config.provider]
  if (!factory) {
    throw new DriverConfigError(
      `this session is client-placed on "${config.provider}", which this app has no driver for — drivers: ${CLIENT_DRIVER_IDS.join(', ')}`,
    )
  }
  return factory(config, host, opts)
}

export { ToolBridge } from './tools.ts'
export type { ToolHandler } from './tools.ts'
export { DriverConfigError } from './types.ts'
export type { ClientDriver, DriverHost, ToolOutcome } from './types.ts'
